import { BkRoutes } from 'bkng';

import { id } from './id/id';

export const campaigns: BkRoutes = [
    {
        path: "id",
        label: "Merchant by ID Campaigns by ID",
        children: id,
    },
];
